import {
    assignModelOptions,
    CompositeModel,
    ConfigConstants,
    CustomInjector,
    ModelOptionsLoaderService,
    ODataObject,
    TextModel,
} from '@evorait/pace-core';

export default class DocBoxFreeSearchModel extends CompositeModel {
    public technicalIdentNo: TextModel;
    public functionalLoc: TextModel;
    public material: TextModel;
    public serialNo: TextModel;

    public constructor() {
        super('DocBoxFreeSearchModel');

        const injector = CustomInjector.getInjector();
        const modelOptionsLoaderService = injector.get(ModelOptionsLoaderService);

        this.technicalIdentNo = <TextModel>this.set(new TextModel('TechnicalIdentNo'));
        modelOptionsLoaderService.load(this.technicalIdentNo, 'DocBoxFreeSearch', 'TechnicalIdentNo');

        this.functionalLoc = <TextModel>this.set(new TextModel('FunctionalLoc'));
        modelOptionsLoaderService.load(this.functionalLoc, 'DocBoxFreeSearch', 'FunctionalLoc');

        this.material = <TextModel>this.set(new TextModel('Material'));
        modelOptionsLoaderService.load(this.material, 'DocBoxFreeSearch', 'Material');

        this.material.options = {
            ...this.material.options,
            applicationIdentifier: ConfigConstants.ApplicationIdentifier.ProductIdentifier,
        };

        this.serialNo = <TextModel>this.set(new TextModel('SerialNo'));
        modelOptionsLoaderService.load(this.serialNo, 'DocBoxFreeSearch', 'SerialNo');

        this.serialNo.options = {
            ...this.serialNo.options,
            applicationIdentifier: ConfigConstants.ApplicationIdentifier.SerialNumber,
        };
    }

    /**
     * Called from markup to reset required and readonly properties of input fields based on the logic that
     * only "Technical Id" or "Functional location" or "Material number" plus "Serial number" can be filled out.
     */
    public resetModelOptions(): void {
        const functionalLocRequired = !this.technicalIdentNo?.value && !this.material.value && !this.serialNo.value;
        const materialRequired = !this.technicalIdentNo?.value && !this.functionalLoc.value;
        const serialNoRequired = !this.technicalIdentNo?.value && !this.functionalLoc.value;

        if (typeof this.technicalIdentNo !== 'undefined') {
            const technicalIdentNoRequired = !this.functionalLoc.value && !this.material.value && !this.serialNo.value;
            this.technicalIdentNo = assignModelOptions(
                this.technicalIdentNo,
                {
                    ...this.technicalIdentNo.options,
                    required: technicalIdentNoRequired,
                    readonly: !technicalIdentNoRequired,
                },
                this,
            );
        }

        // set readonly and required options
        this.functionalLoc = assignModelOptions(
            this.functionalLoc,
            {
                ...this.functionalLoc.options,
                required: functionalLocRequired,
                readonly: !functionalLocRequired,
            },
            this,
        );
        this.material = assignModelOptions(
            this.material,
            {
                ...this.material.options,
                required: materialRequired,
                readonly: !materialRequired,
            },
            this,
        );
        this.serialNo = assignModelOptions(
            this.serialNo,
            {
                ...this.serialNo.options,
                required: serialNoRequired,
                readonly: !serialNoRequired,
            },
            this,
        );
    }

    public getOutModel(): ODataDocBoxFreeSearchOutModel {
        // create outmodel
        const outModel = <ODataDocBoxFreeSearchOutModel>super.getOutModel();
        if (outModel.TechnicalIdentNo) {
            outModel.TechnicalIdentNo = outModel.TechnicalIdentNo.toUpperCase();
        }
        return outModel;
    }
}

export interface ODataDocBoxFreeSearchOutModel extends ODataObject {
    TechnicalIdentNo: string;
    FunctionalLoc: string;
    Material: string;
    SerialNo: string;
}
